import Vue from 'vue'
import Vuex from 'vuex'
import Http from '@/http/index'
import HttpsEncrypt from "@/http/indexencrypt";
import getCurrentCityName from "@/getCurrentCityName";
import crypto from '@/crypto/crypto'
import axios from "axios";

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        devicecode: '',//浏览器信息
        address:sessionStorage.getItem("address"),//通过经纬度获取的地址
        latlon: sessionStorage.getItem("latlon"),//经纬度
        network: '',//网络

        userInfo: localStorage.getItem('userData') ? crypto.get(localStorage.getItem('userData')) : '',
        tabList: localStorage.getItem('tabList') ? crypto.get(localStorage.getItem('tabList')) : '[]',


    },
    mutations: {
        // 赋值网络
        SET_NETWORK: (state, network) => {
            state.network = network
        },
        // 赋值经纬度
        SET_LATLON: (state, latlon) => {
            state.latlon = latlon
        },
        //通过经纬度获取的地址
        SET_Address: (state, address) => {
            state.address = address
        },
        //浏览器信息
        SET_Devicecode: (state, devicecode) => {
            state.devicecode = devicecode
        },

    },
    getters: {
        uuid: state => state.uuid,
        network: state => state.network,
        latlon: state => state.latlon,

        userInfo: state => state.userInfo,
        tabList: state => state.tabList,
    },
    actions: {
        /*****************************************************************
         *
         * 获取设备唯一码
         *
         *****************************************************************/
        getSebeihao({commit},getters) {
            commit('SET_Devicecode', navigator.userAgent)

            var latlonTime = sessionStorage.getItem('latlonTime') ? sessionStorage.getItem('latlonTime') : null
            var nowTime = Date.now();
            if ((latlonTime&&(nowTime - latlonTime > 10 * 60 * 1000))||!latlonTime||!getters.latlon||Vue.prototype.$UserBehaviorsort==1) {
                //超出10分钟了
                getCurrentCityName().then(city => {
                    if (city) {
                        var x = city.point.lng - 0.0065, y = city.point.lat - 0.006;
                        let x_pi = 3.14159265358979324 * 3000.0 / 180.0;
                        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
                        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
                        var gcjLon = z * Math.cos(theta);
                        var gcjLat = z * Math.sin(theta);
                        let latlon = gcjLat + ',' + gcjLon
                        commit('SET_LATLON', latlon)
                        commit('SET_Address', city.address)
                        sessionStorage.setItem("latlon", latlon);
                        sessionStorage.setItem("address", city.address);
                        sessionStorage.setItem('latlonTime', new Date().getTime())
                    }
                })
            }
        },


        /*****************************************************************
         *
         * 记录各个操作
         *
         *****************************************************************/
        saveUserBehavior({getters}, infor) {
            let library_id = null;
            if (localStorage.getItem('userData')) {
                let kk = JSON.parse(JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userData'))).parameter).department_library_arrid
                if (kk.length == 1) {
                    library_id = kk[0]
                } else {
                    library_id = ''
                }
            }

            Vue.prototype.$UserBehaviorsort++
            let data = {
                devicecode: getters.devicecode,//浏览器信息
                address:getters.address,//通过经纬度获取的地址
                wificode:'',
                latlon: getters.latlon,// 经纬度
                path: infor.path ? infor.path : Vm.$route.path,// 路由
                name: infor.name ? infor.name : null,//路由名称/操作名称
                member_id:(localStorage.getItem('userData') ? JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userData'))).id : null),
                library_id:library_id,
                network:'',
                other_id:infor.other_id?infor.other_id:null,//进入详情时的主键id
                terminal: '',//终端类型1阿启泰书籍文献管理端2智慧文博管理端
                created_at: Vue.prototype.$getNowTime(),//年月日时分秒
                sort: Vue.prototype.$UserBehaviorsort,
                type: infor.type ? infor.type : 0,
                lang:'zh',
                apiterminal: 'Aqt_20230517ApiWeb',

            }
            HttpsEncrypt.post('api/user/v3/userpageviews/add', data).then(val => {
            }).catch(err => {
            })
        },
    }


})
